export class RowFormatting {
	BackgroundColour: string;
	Field: string;
	DataItemField: string;
	FontSize: string;
	FontWeight: string;
	FormatOn: boolean;
	FromOperation: string;
	FromValue: string;
	RowHeight: string;
	TextAlignment: string;
	ToOperation: string | null;
	ToValue: string;
	UserEdit: boolean;
	id: number;

	constructor(data?: Partial<RowFormatting>) {
		// Initialize with default values
		this.BackgroundColour = data?.BackgroundColour || '';
		this.Field = data?.Field || '';
		this.FontSize = data?.FontSize || '';
		this.FontWeight = data?.FontWeight || '';
		this.FormatOn = data?.FormatOn || false;
		this.FromOperation = data?.FromOperation || '=';
		this.FromValue = data?.FromValue || '';
		this.RowHeight = data?.RowHeight || '';
		this.TextAlignment = data?.TextAlignment || '';
		this.ToOperation = data?.ToOperation || null;
		this.ToValue = data?.ToValue || '';
		this.UserEdit = data?.UserEdit || false;
		this.id = data?.id || Date.now();
	}

	// Optional: Add methods for common operations
	public toJSON(): string {
		return JSON.stringify({
			BackgroundColour: this.BackgroundColour,
			Field: this.Field,
			FontSize: this.FontSize,
			FontWeight: this.FontWeight,
			FormatOn: this.FormatOn,
			FromOperation: this.FromOperation,
			FromValue: this.FromValue,
			RowHeight: this.RowHeight,
			TextAlignment: this.TextAlignment,
			ToOperation: this.ToOperation,
			ToValue: this.ToValue,
			UserEdit: this.UserEdit,
			id: this.id,
		});
	}

	public static fromJSON(json: string): RowFormatting {
		const data = JSON.parse(json);

		return new RowFormatting(data);
	}
}

// Interface for the settings container
export interface GridRowSettings {
	records: RowFormatting[];
}